<template>
  <div>
    <div class="form-personnal">
      <div class="ip">
        <vs-input class="w-full"
        v-model="form.ancien_mot_de_passe"
        :danger="errors.ancien_mot_de_passe ? true : false"
        :danger-text="errors.ancien_mot_de_passe ? errors.ancien_mot_de_passe[0] : ''"
        type="password"
        label="Ancien mot de passe">
        </vs-input>
      </div>
      <div class="ip">
        <vs-input class="w-full"
        v-model="form.mot_de_passe"
        :danger="errors.mot_de_passe ? true : false"
        :danger-text="errors.mot_de_passe ? errors.mot_de_passe[0] : ''"
        type="password" label="Nouveau mot de passe"></vs-input>
      </div>
      <div class="ip">
        <vs-input class="w-full"
        v-model="form.mot_de_passe_confirmation"
        :danger="errors.mot_de_passe_confirmation ? true : false"
        :danger-text="errors.mot_de_passe_confirmation ? errors.mot_de_passe_confirmation[0] : ''"
        type="password" label="Confirmer le mot de passe"></vs-input>
      </div>
    </div>
    <div class="bt-section">
      <vs-button @click="updatePassword">Sauvegarder</vs-button>
    </div>
  </div>
</template>

<script>
const default_value = {
  id: '',
  ancien_mot_de_passe: '',
  mot_de_passe: '',
  mot_de_passe_confirmation: ''
}
export default {
  data: () => ({
    form: {
      id: '',
      ancien_mot_de_passe: '',
      mot_de_passe: '',
      mot_de_passe_confirmation: ''
    },
    user: {},
    errors: []
  }),
  mounted(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  methods:{
    updatePassword(){
      this.form.id = this.user.id
      this.$vs.loading()
      this.$http.post('users/password', this.form).then((res) => {
        this.errors = []
        this.$vs.loading.close()
        if (res.data.status){
          this.form = { ...default_value }
          this.$vs.notify({
            time: 5000,
            title: 'Succès!',
            text: "Opération effectuée avec succès",
            color: 'success',
            iconPack: 'feather',
            position: 'top-right',
            icon: 'icon-check-circle'
          })
        }else{
          this.$vs.notify({
            time: 5000,
            title: 'Error!',
            text: "Une erreur est survenue lors de l'opération",
            color: 'error',
            iconPack: 'feather',
            position: 'top-right',
            icon: 'icon-check-circle'
          })
        }
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 422){
          this.errors= error.response.data.errors
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-personnal{
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .ip{
    width: 32%;
  }
  .bt-section{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
</style>
